import React, { useState, useEffect } from "react";
import { carousel, ganesh, GANESH_SEASON_ENABLED } from "../data/Data";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "../css/components.css";
import { addToCart, getCartTotal } from "../redux/CartSlice";
import { useDispatch } from "react-redux";




export default function Banner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const handleShopNow = () => {
    navigate('/shop');
  };

  const handleFeaturedProduct = () => {
    if (!GANESH_SEASON_ENABLED) return;
    navigate(`/item/${ganesh.product_name_key}`);
  };
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    customPaging: (i) => (
      <div className={`custom-dot ${i === currentSlide ? 'active' : ''}`}></div>
    ),
    dotsClass: 'slick-dots custom-dots'
  };
  return (
    <>
      <div className="modern-banner-container">
        <div className="banner-wrapper">
          <Slider {...settings}>
            {carousel.map((val, index) => (
              <div key={index} className="banner-slide">
                <div className="banner-content-wrapper">
                  {/* Background Images */}
                  <div className="banner-image-container">
                    <img
                      className="banner-image desktop-banner"
                      src={val.cover_img}
                      alt="NT Sticks premium fragrance collection"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                    <img
                      className="banner-image mobile-banner"
                      src={val.cover_img_mobile}
                      alt="NT Sticks premium fragrance collection"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                    <div className="banner-overlay"></div>
                  </div>
                  
                  {/* Content */}
                  <div className="banner-content">
                    <div className="container">
                      <div className="row align-items-center min-vh-60">
                        <div className="col-lg-6 col-md-8">
                          <div className={`banner-text ${isLoaded ? 'animate-in' : ''}`}>
                            <div className="brand-badge">
                              <span className="badge-text">Factory-to-Home Luxury</span>
                            </div>
                            
                            <h1 className="banner-title">
                              Premium Long-Lasting Fragrances,
                              <br />Fresh From Our Indore Factory.
                            </h1>
                            
                            <p className="banner-description">
                              Experience intense aroma, charcoal-free bliss and millennial-ready packaging. Shop retail collections or request bulk pricing directly from our factory.
                            </p>
                            
                            <div className="banner-features">
                              <div className="feature-item">
                                <i className="fa fa-fire"></i>
                                <span>Long-lasting intense aroma</span>
                              </div>
                              <div className="feature-item">
                                <i className="fa fa-industry"></i>
                                <span>Direct from factory pricing</span>
                              </div>
                              <div className="feature-item">
                                <i className="fa fa-leaf"></i>
                                <span>Low smoke, charcoal-free blends</span>
                              </div>
                            </div>
                            
                            <div className="banner-actions">
                              <button 
                                className="btn-professional-primary"
                                onClick={handleShopNow}
                              >
                                <span>Shop Retail Collection</span>
                                <i className="fa fa-arrow-right"></i>
                              </button>
                              
                              <button 
                                className="btn-professional-secondary"
                                onClick={() => navigate('/wholesale')}
                              >
                                <span>Request Bulk Quote</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        
                        {GANESH_SEASON_ENABLED && (
                          <div className="col-lg-6 d-none d-lg-block">
                            <div className="banner-product-showcase">
                              <div style={{cursor: "pointer"}} className="floating-product-card" onClick={handleFeaturedProduct}>
                                <img 
                                  src="../assets/nt/ganesh12.jpg" 
                                  alt="Eco-Friendly Ganesh Kit"
                                  className="product-image"
                                />
                                <div className="product-info">
                                  <h4>Eco-Friendly Ganesh Kit</h4>
                                  {/* Read from the product record instead of
                                      hardcoded — this card had drifted to ₹999
                                      with a "13% OFF" that matched neither the
                                      shop card nor the product page. */}
                                  <div className="price-info">
                                    <span className="current-price">₹{ganesh.price}</span>
                                    {Number(ganesh.mainPrice) > Number(ganesh.price) && (
                                      <>
                                        <span className="original-price">₹{ganesh.mainPrice}</span>
                                        <span className="discount">
                                          {Math.round(
                                            ((Number(ganesh.mainPrice) -
                                              Number(ganesh.price)) /
                                              Number(ganesh.mainPrice)) *
                                              100
                                          )}
                                          % OFF
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        
        {/* Trust Indicators */}
        <div className="trust-indicators">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="trust-item">
                  <div className="trust-icon">
                    <i className="fa fa-truck"></i>
                  </div>
                  <div className="trust-content">
                    <h6>Free Shipping</h6>
                    {/* Matches the cart, which drops the ₹50 delivery charge
                        above ₹200 (Cart.js). This said ₹500, so the site was
                        advertising a worse deal than it actually gives. */}
                    <p>On orders above ₹200</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="trust-item">
                  <div className="trust-icon">
                    <i className="fa fa-shield-alt"></i>
                  </div>
                  <div className="trust-content">
                    <h6>Quality Assured</h6>
                    <p>100% authentic products</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="trust-item">
                  <div className="trust-icon">
                    <i className="fa fa-undo"></i>
                  </div>
                  <div className="trust-content">
                    <h6>Damage Covered</h6>
                    <p>Report within 48 hours</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="trust-item">
                  <div className="trust-icon">
                    <i className="fa fa-headset"></i>
                  </div>
                  <div className="trust-content">
                    <h6>24/7 Support</h6>
                    <p>Customer care available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
